import React from 'react'
import { DropdownMenu, Button, MoreIcon } from 'stylist'
import { square } from 'styles/buttons'

const MoreMenu = ({ children, horizontal, kind = 'ghost' }) => (
  <DropdownMenu
    align="right"
    trigger={toggle => (
      <Button className={square()} kind={kind} onClick={toggle}>
        <MoreIcon
          size="1.25rem"
          direction={horizontal ? 'horizontal' : 'vertical'}
        />
      </Button>
    )}
  >
    {children}
  </DropdownMenu>
)

export default MoreMenu



// WEBPACK FOOTER //
// ./src/components/MoreMenu.js